<!--
程序名：问卷填写页面
功能：用户打开问卷链接对问卷进行填写
-->
<template>
  <div class="display">
    <div class="content">
      <h3>{{ title }}</h3>
      <div class="top" v-if="desc!=''">
        {{ desc }}
      </div>
      <el-card class="box-card" v-for="(item,index) in detail">
        <div slot="header" class="clearfix">

          <div class="questionTitle">
            <!--显示必填标识-->
            <span style="color: #F56C6C;">
              <span v-if="item.requiredFlag==='1'">*</span>
              <span v-else>&nbsp;</span>
            </span>
            {{ (index + 1) + '.' + item.questionDescription }}
            <!--            {{item.questionName+'.'+item.questionDescription}}-->
          </div>
        </div>
        <!--单选题展示-->

        <div class="text item" v-if="item.questionType==='1'" v-for="optionItem in item.optionList">
          <el-radio v-model="item.radioValue" :label="optionItem.optionSgin" style="margin: 5px;"
                    @input="confirmRadio(optionItem.optionId,index)">
            {{ optionItem.optionName }}
          </el-radio>
        </div>

        <!--多选题展示-->
        <el-checkbox-group v-if="item.questionType==='2'" v-model="item.checkboxValue">
          <div class="text item" v-for="optionItem in item.optionList">
            <el-checkbox :label="optionItem.optionSgin" style="margin: 5px;">{{ optionItem.optionName }}</el-checkbox>
          </div>
        </el-checkbox-group>
        <!--填空题展示-->
        <el-input
          v-if="item.questionType==='3'"
          type="textarea"
          v-model="item.textValue"
          resize="none">
        </el-input>
        <!--          :rows="item.row"-->
      </el-card>
      <el-button type="primary" style="margin: 5px;" @click="submit">{{ submitText }}
        <!--        :loading="submitLoading"-->
      </el-button>
      <div class="bottom">
        <!--        <el-link type="info" href="/index">问卷喵&nbsp;提供技术支持</el-link>-->
      </div>
    </div>
  </div>
</template>
<script>
// import {answerOpera} from './api'
export default {
  data() {
    return {
      dialogShow: false,
      dialogTitle: '',
      dialogType: 1,//1添加 2修改
      oldItem: null,//编辑中问题的对象
      willAddQuestion: {
        type: '',
        title: '',
        options: [''],
        text: '',
        row: 1,
      },
      allType: [
        {
          value: 'radio',
          label: '单选题',
        },
        {
          value: 'checkbox',
          label: '多选题',
        },
        {
          value: 'text',
          label: '填空题',
        },
      ],
      title: '',
      desc: '',
      detail: [],
      hasOption: [],
      startTimestamp: 0,//填写问卷开始时间戳 毫秒
      submitLoading: false,//提交按钮 加载中状态
      submitText: '提交',//提交按钮文字
      wj:'',

    }
  },
  mounted() {
    var wjId = this.$route.query.wjId;
    if(wjId){
      this.$http.get("/survey/getSurveyInfo/" + wjId).then(res => {
        this.handleData(res)
      })
    }else{
      this.$http.get("/survey/get").then(res => {
        this.handleData(res)
      })
    }
    this.startTimestamp = new Date().getTime();//时间戳 毫秒
  },
  methods: {
    handleData(res){
      if (res.code === 200) {
        this.wjId=res.data.id
        this.title = res.data.surveyName;
        this.desc = res.data.surveyDescription;
        let allQuestion = res.data.questionList.map(item => {
          return {
            ...item,
            radioValue: -1,
            checkboxValue: [],
            textValue: ''
          }
        })
        this.detail = allQuestion.filter(item => {
          return item.optionId === 0
        })
        this.hasOption = allQuestion.filter(item => {
          return item.optionId !== 0
        })
        document.surveyName = res.data.surveyName;
      } else {
        this.$messageUi({
          type: 'error',
          message: res.message
        });
      }
    },
    confirmRadio(optionId, id) {
      let tempadd = this.hasOption.filter(item => {
        return item.optionId === optionId
      })
      let detailLength=this.detail.length
      if((id+1)<detailLength){
        if (this.detail[id + 1].optionId !== 0) {
          this.detail.splice(id + 1, 1)
        }
      }
      let length = tempadd.length
      if (length > 0) {
        for (var i = 1; i <= length; i++) {
          this.detail.splice(id + i, 0, tempadd[i - 1])
        }
      }
    },
    //提交问卷
    submit() {
      this.submitLoading = true;
      var wjId = this.wjId;
      let sendData = []
      let temp = []
      this.detail.forEach(item => {

        let value = ""
        if (item.questionType === "1") {
          value = item.radioValue
        } else if (item.questionType === "2") {
          value = item.checkboxValue.join(',')
        } else {
          value = item.textValue
        }
        if (item.requiredFlag === '1') {
          if (value === '') {
            temp.push(item.questionDescription)
          }
        }
        let obj = {
          questionId: item.id,
          optionContent: value
        }
        sendData.push(obj)
      })
      if (temp.length === 0) {
        this.$http({
          method: "post",
          url: "/survey/submit/" + wjId,
          data: sendData
        })
          .then(data => {
            console.log(data);
            if (data.code === 200) {
              //提交成功
              this.submitLoading = false;
              this.submitText = '提交成功';
              this.$router.push('/thanks')
              // this.$router.push({path:'/thankyou'});//跳到欢迎页
            } else {
              this.submitLoading = false;
              this.submitText = '提交';
              this.$messageUi.error({
                message: data.message,
              });
            }
          })
      } else {
        this.$messageUi.error({
          message: temp.join(',') + '为必填项，请填写'
        })
      }

    }
  }
}
</script>
<style scoped>
.display {
  text-align: center;
  padding: 20px;
}

.display .top {
  color: #606266;
  padding: 0 10px 10px 10px;
  border-bottom: 3px solid #409EFF;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
}

.display .content {
  width: 100%;
  max-width: 800px;
  display: inline-block;
  text-align: center;
}

.display .box-card {
  text-align: left;
  width: 100%;
  margin: 10px 0 10px 0;
}

.display .bottom {
  margin: 20px 10px 20px 10px;
  color: #909399;
}

.display a:link, a:visited, a:active {
  color: #909399;
  text-decoration: none;
}
</style>
